import TravelExploreOutlinedIcon from '@mui/icons-material/TravelExploreOutlined';
import { Stack, Typography } from '@mui/material';
import React from 'react';

import { muiPalette } from '@/shared/general-theme';

interface NoContentPlaceholderProps {
  title: string;
  subtitle?: string;
}

const EmptyContent: React.FC<NoContentPlaceholderProps> = ({
  title,
  subtitle = '',
}) => {
  return (
    <Stack
      gap='1rem'
      width='100%'
      minHeight='20rem'
      alignItems='center'
      justifyContent='center'
      padding='2rem'
    >
      <TravelExploreOutlinedIcon fontSize='large' />
      <Typography variant="h6" color={muiPalette.text.secondary}>
        {title}
      </Typography>

      {subtitle && (
        <Typography variant={'body2'} color={muiPalette.text.secondary}>
          {subtitle}
        </Typography>
      )}
    </Stack>
  );
};

export default EmptyContent;
